import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { useEffect } from 'react';
import { sortChatsByRecentlyActive } from '../utils/timestamps';

/**
 * Підписка на список чатів (без вкладених повідомлень)
 */
export const useChatListSubscription = ({ user, db, messagesCacheRef, setChats }) => {
  useEffect(() => {
    if (!user) return;

    const chatsRef = collection(db, 'chats');
    const q = query(chatsRef, where('type', '==', 'VIN'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const newChats = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Сортуємо за активністю
      const sortedChats = sortChatsByRecentlyActive(newChats);

      // Додаємо кешовані повідомлення
      const chatsWithMessages = sortedChats.map((chat) => ({
        ...chat,
        messages: messagesCacheRef.current[chat.id] || [],
      }));

      setChats(chatsWithMessages);
    });

    return () => {
      unsubscribe();
    };
  }, [db, user, messagesCacheRef, setChats]);
};
